import Badge from 'components/badge/badge';
import CompanyAction from 'components/companies/CompanyAction';
import CompanySizeBadge from 'components/companies/CompanySizeBadge';
import useText from 'hooks/useText';
import MobileListCard from './MobileListCard';

/**
 * A company of the list on a phone (pages/companies/companiesItems.js
 * describes it): its category, its class, its next action, the date of its
 * tab; a lost company says why and when to try again. `sizeThresholds` (of
 * the list's answer) feed the tooltip of the class.
 */
const CompanyMobileCard = ({ company, tab, isSelected, onOpen, sizeThresholds = null }) => {
  const { text } = useText('companies');
  const { text: recordText } = useText('recordForm');
  const lostReasonLabel = company.lostReason ? recordText(`reason_${company.lostReason}`) : '';
  const lost = tab === 'lost';
  let metaItems = [];
  if (lost) {
    metaItems = [
      { label: text('columnLostOn'), value: company.lostOn },
      { label: text('columnReason'), value: lostReasonLabel || company.lostReason },
    ];
  } else if (company.since) {
    metaItems = [{ label: tab === 'prospects' ? '' : text('columnClientSince'), value: company.since }];
  }
  const next = lost ? company.relaunchOn && company.relaunch : company.action;
  const badges = [
    company.sizeLabel && (
      <CompanySizeBadge
        key="size"
        label={company.sizeLabel}
        size={company.size}
        sizeSource={company.sizeSource}
        thresholds={sizeThresholds}
      />
    ),
    next && (
      <CompanyAction key="action" nextAction={lost ? null : company.nextAction} companyId={company._id}>
        {next}
      </CompanyAction>
    ),
  ].filter(Boolean);
  return (
    <MobileListCard
      title={company.name}
      subtitle={[company.department, company.groups].filter(Boolean).join(' · ')}
      isSelected={isSelected}
      onClick={() => onOpen(company._id)}
      topRightBadge={company.category ? <Badge type={company.category.badge}>{company.category.label}</Badge> : null}
      badge={badges.length ? <div className="flex flex-wrap items-center gap-2">{badges}</div> : null}
      metaItems={metaItems}
    />
  );
};

export default CompanyMobileCard;
